import { DEFAULT_LANGUAGE, IS_DEVELOPMENT } from '~/modules/config';
import { ENGLISH_LANGUAGE_CODE, JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';

export function getUserLanguage() {
    return (
        (IS_DEVELOPMENT && new URLSearchParams(window.location.search).get('lang')) ||
        document.documentElement.getAttribute('lang') ||
        DEFAULT_LANGUAGE
    );
}

export function getPreferredLanguage(): string {
    return getUserLanguage() === JAPANESE_LANGUAGE_CODE ? JAPANESE_LANGUAGE_CODE : ENGLISH_LANGUAGE_CODE;
}
